<template>
  <b-card id="history-report" class="container-card pt-5">
    <overlay-loading :loading="loading.tableData">
      <template #content>
        <!-- <b-table
          :key="`key-${keyChange}`"
          responsive
          bordered
          borderless
          sticky-header
          show-empty
          no-local-sorting
          :fields="fields"
          :items="historyReportList"
          :busy="loading.tableData"
          class="default-static-table"
          :class="{ 'loading-table': loading.tableData }"
        > -->
        <b-table
          :key="`key-${keyChange}`"
          responsive
          bordered
          borderless
          sticky-header
          show-empty
          no-local-sorting
          :fields="fields"
          :items="historyReportList"
          :busy="loading.tableData"
          class="default-static-table-vertical"
          :class="{ 'loading-table': loading.tableData }"
        >
          <template #cell(filter)="data">
            <span v-if="data.item.filter">
              {{ data.item.filter }}
            </span>
            <span v-else>{{ "-" }}</span>
          </template>
          <template #cell(updatedtime)="data">
            <span v-if="data.item.updatedtime">
              <!-- {{ resolveDateWithSeperator(data.item.updatedtime, true) }} -->
              {{ resolveDate(data.item.updatedtime, "dd/MM/yyyy") }}
            </span>
            <span v-else>{{ "-" }}</span>
          </template>
          <template #cell(date_time)="data">
            <span v-if="data.item.querystarttime && data.item.queryendtime">
              {{
                resolveDateWithComparator(
                  data.item.querystarttime,
                  data.item.queryendtime
                )
              }}
            </span>
            <span v-else>{{ "-" }}</span>
          </template>
          <template #cell(progress)="data">
            <span>{{ `${data.item.progress}%` }}</span>
          </template>
          <template #cell(status)="data">
            <div class="d-flex align-items-center">
              <div
                class="status-icon mr-2"
                :class="
                  data.item.status == 4
                    ? 'complete'
                    : data.item.status == 3
                    ? 'failed'
                    : 'pending'
                "
              />
              <div>{{ data.item.status_desc }}</div>
            </div>
          </template>
          <template #cell(actions)="data">
            <div v-if="isAdjusted" class="d-flex align-items-center">
              <button
                v-b-tooltip.hover
                title="Export .CSV"
                :disabled="!data.item.fileurl"
                :class="data.item.fileurl ? 'active' : 'disabled'"
                class="download-button"
                @click="onClickDownload(data.item.report_job_id)"
              >
                <div
                  class="d-flex flex-column justify-content-center align-items-center"
                >
                  <download-icon />
                </div>
              </button>
              <a
                :ref="`download-${data.item.report_job_id}`"
                :href="data.item.fileurl"
                download
              />
              <button
                v-b-tooltip.hover
                title="Delete"
                class="default-btn-action trash-button"
                @click="onClickDelete(data.item)"
              >
                <b-spinner v-if="data.item.loading" small variant="primary" />
                <trash-icon v-else />
              </button>
            </div>
          </template>
          <template #empty>
            <card-no-item :text-no-img="'Item Not Found'" />
          </template>
        </b-table>
      </template>
    </overlay-loading>
    <pagination-with-reorder
      entity-editable
      :pagination="pagination"
      @entityChange="onFilterEntity"
      @pageChange="onPageChange"
    />
  </b-card>
</template>

<script>
import PaginationWithReorder from "@/views/components/pagination/PaginationWithReorder.vue";
import DownloadIcon from "@/@core/components/svg/common/Download.vue";
import TrashIcon from "@/@core/components/svg/common/Trash.vue";
import CardNoItem from "@core/components/card-no-item/CardNoItem.vue";

import useHistoryReport from "./hooks/useHistoryReport";

export default {
  components: {
    PaginationWithReorder,
    DownloadIcon,
    TrashIcon,
    CardNoItem,
  },
  props: {
    isAdjusted: {
      type: Boolean,
      default: false,
    }
  },
  setup() {
    const {
      fields,
      historyReportList,
      loading,
      pagination,
      keyChange,
      resolveDateWithSeperator,
      resolveDateWithComparator,
      resolveDate,
      onPageChange,
      onFilterEntity,
      onClickDownload,
      onClickDelete,
    } = useHistoryReport();

    return {
      fields,
      historyReportList,
      loading,
      pagination,
      keyChange,
      resolveDateWithSeperator,
      resolveDateWithComparator,
      resolveDate,
      onPageChange,
      onFilterEntity,
      onClickDownload,
      onClickDelete,
    };
  },
};
</script>

<style scoped>
@import "~@/assets/css/pages/report/history-report.css";
@import "~@/assets/css/pages/default-static-table.css";
</style>
